import posthog from 'posthog-js';

import { logger } from 'src/logger';

// Project tokens are used to decide which project within PostHog to place the event into.
// These are exposed to the browser and are not secrets.
const STAGE = 'prod'.toLowerCase();
const PUBLIC_POSTHOG_PROJECT_TOKEN =
  STAGE === 'prod'
    ? 'phc_8w5OtJQxITg2qZOfx9w4hZrdZVOlc1yXBMVlRbdeYJW'
    : 'phc_9t2NaA4EuvBc1KeCiGta3WhpXEHSqlnOVlmQ2f03zMR';

/**
 * Fetches user information from the ACPS getPrimaryContactInformation endpoint
 * Returns the user's obfuscated customer ID for PostHog identification (privacy-safe)
 */
const getUser = async (): Promise<{ user?: string } | null> => {
  try {
    const response = await fetch('/acps/getPrimaryContactInformation');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    // Return null if data is null/undefined or if obfuscatedCustomerId is not available
    if (!data || !data.obfuscatedCustomerId) {
      return null;
    }

    // Use obfuscatedCustomerId as the user identifier for PostHog (privacy-safe)
    return { user: data.obfuscatedCustomerId };
  } catch (error) {
    logger.error('Failed to fetch user information for Tricorder', error as Error);
    return null;
  }
};

export const initTricorder = async () => {
  if (STAGE === 'gamma') {
    // Tricorder only has beta / prod setup completed, potentially resulting in browser errors in gamma.
    // We will skip gamma metrics for stability and reducing error noisiness.
    return;
  }

  const PUBLIC_POSTHOG_HOST = '/tricorder';
  const userObj = await getUser();
  const userAlias = userObj?.user;
  if (!userAlias) {
    logger.warn('Error initializing Posthog - Unable to fetch user alias.');
    return;
  }

  try {
    posthog.init(PUBLIC_POSTHOG_PROJECT_TOKEN, {
      api_host: PUBLIC_POSTHOG_HOST,
    });

    posthog.identify(userAlias);
  } catch (e) {
    logger.warn('Error initializing Posthog', e as Error);
  }
};
